import { Button, Image, Modal, Switch, Table } from "antd";
import HeaderList from "../../../components/HeaderList";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plus-filled.svg";
import { ReactComponent as EditIcon } from "../../../assets/icons/edit.svg";
import useVouchers from "../hooks/useVouchers";
import styles from "../styles/styles.module.css";
import useModal from "../../../hooks/useModal";
import VoucherForm from "./VoucherForm";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllProducts } from "../../../redux/slices/products";
import { selectUser } from "../../../redux/slices/user";
import moment from "moment";

const VouchersUI = () => {
  const { isModalOpen, toggleModal } = useModal();
  const { vouchers, getVoucherList, enableDisableVoucher } = useVouchers();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [loading, setLoading] = useState(null);
  const [voucherSelected, setVoucherSelected] = useState(undefined);

  const columns = [
    {
      title: "Imagen del cupón",
      dataIndex: "image",
      render: (path) => (
        <Image preview={false} src={path} width={330} height={130} />
      ),
      align: "center",
    },
    {
      title: "Nombre",
      dataIndex: "name",
    },
    {
      title: "Programado",
      dataIndex: "date",
      align: "center",
      render: (text) => <div dangerouslySetInnerHTML={{ __html: text }} />,
    },
    {
      title: "Aplicados",
      dataIndex: "applied",
      align: "center",
    },
    {
      title: "Target",
      dataIndex: "selected_users",
      align: "center",
      render: (value) => (value ? "SELECTIVO" : "GENERAL"),
    },
    {
      title: "Estatus",
      dataIndex: "status",
      align: "center",
      render: (value, record) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 6,
            alignItems: "center",
          }}
        >
          <Switch
            onChange={async () => {
              setLoading(record.id);
              await enableDisableVoucher(record.id);
              await getVoucherList();
              setLoading(null);
            }}
            loading={loading === record.id}
            checked={value}
          />
          {value ? "Activo" : "Inactivo"}
        </div>
      ),
    },
    {
      title: "Acción",
      dataIndex: "action",
      align: "center",
      render: (_, record) => (
        <div>
          <Button
            onClick={() => {
              toggleModal();
              setVoucherSelected(record);
            }}
            style={{
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              margin: "0 auto",
            }}
            icon={<EditIcon style={{ width: 24, height: 24 }} />}
            type="link"
          />
          <span style={{ marginTop: 4, display: "block" }}>Editar</span>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getVoucherList();
    dispatch(getAllProducts(user.branch));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFinish = () => {
    toggleModal();
    getVoucherList();
    setVoucherSelected(undefined)
  };

  console.log('vouchers', vouchers)

  return (
    <>
      <HeaderList
        title={"CUPONES"}
        back={"/ajustes"}
        actions={
          <Button
            onClick={toggleModal}
            icon={<PlusIcon />}
            className={styles["new-voucher-btn"]}
          >
            NUEVO CUPÓN
          </Button>
        }
      />
      <Table
        dataSource={vouchers?.cupones?.map((voucher) => ({
          ...voucher,
          date: `Desde: ${moment(voucher.date_start).format(
            "DD/MM/YYYY"
          )}<br/><br/>Hasta: ${moment(voucher.date_end).format("DD/MM/YYYY")}`,
        }))}
        columns={columns}
      />

      <Modal
        style={{ textAlign: "center" }}
        footer={null}
        title="NUEVO CUPÓN"
        onCancel={() => {
          toggleModal()
          setVoucherSelected(undefined)
        }}
        visible={isModalOpen}
        destroyOnClose
      >
        <VoucherForm voucherSelected={voucherSelected} onFinish={onFinish} />
      </Modal>
    </>
  );
};

export default VouchersUI;
